import { AppstoreOutlined, BarsOutlined } from '@ant-design/icons';
import { Input, Segmented, Spin } from 'antd';
import { debounce } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import { generatePath, useLoaderData, useNavigate, useSearchParams } from 'react-router-dom';
import { getProductionList } from '../../api/vendor/vendorProduction';
import KanabanBoard from '../../components/data/kanaban/kanaban';
import { Page } from '../../components/page';
import { InfiniteTable } from '../../components/table';
import { useFetch } from '../../hooks';
import { ProductionColumn, ProductionKanabanColumn } from '../../library/constants';
import { searchParamsToObject } from '../../library/helpers';
import { formatDate } from '../../library/utils';

const VIEW_MODES = Object.freeze({
    LIST: "list",
    KANABAN: "kanaban",
})

const renderKanabanCard = ({ item, onClick }) => {
    return (<div className='kanaban__card' onClick={() => onClick(item)}>
        <div className="kanaban__card__header">
            {/* {item.supplier_flow === 2 && <p className='priority'>Only vendor</p>} */}
            {item.client_expected_delivery_date && <p className='priority'>Deadline Delivery :  {formatDate(String(item.client_expected_delivery_date))}</p>}
        </div>
        <div className="kanaban__card__body">
            <p className='itemName'>{item.name == null ? item.default_name : item?.name}</p>
            <p className='itemName'>Quantity : {item?.approved_quantity}</p>
        </div>
        <div className="kanaban__card__footer">
            <div className="details">
                <p className='head'>Project ID</p>
                <p className='leftHead'>Recieved Date</p>
                <p className='value'>{item.id}</p>
                <p className='leftValue'>{formatDate(String(item?.updatedAt))}</p>
            </div>
        </div>

    </div>
    );
};

const ProductionListView = ({ data, isLoading = false, hasMore, onChangeSort, onLoadMore, onItemClick }) => {
    return (
        <InfiniteTable
            columns={ProductionColumn}
            data={data}
            /* perPage={Number(meta?.limit)} currentPage={Number(meta?.page)} total={Number(meta?.totalCount)} */
            isLoading={isLoading}
            onChange={onChangeSort}
            onRowClick={(_, record) => onItemClick(record)}
            hasMore={hasMore}
            loadMore={onLoadMore}

        />
    )
}

ProductionListView.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    isLoading: PropTypes.bool,
    hasMore: PropTypes.bool.isRequired,
    onChangeSort: PropTypes.func.isRequired,
    onLoadMore: PropTypes.func.isRequired,
    onItemClick: PropTypes.func.isRequired
}

/** 
 * Supplier columns (supplier_flow)
 * 
 *  0 ==> if finisher is not selected or finsiher and vendor are same  (purana wala flow) 
    1 ==> only finisher          (purana wala flow with some minor changes)                                                 
    2 ==> is only supplier (finisher is also selected and is different)  (naya wala flow)
 * 
 */



const ProductionItemKanabanView = ({ data, isLoading = false, hasMore, onLoadMore, onItemClick }) => {
    const columns = ProductionKanabanColumn.map(column => ({
        ...column,
        items: data.filter(({ vendor_delivery_status, vendor_status, supplier_flow }) => {
            if (supplier_flow === 2) {
                return vendor_delivery_status === column.supplierStatus
            }
            return vendor_status === column.key    //purana wala flow

        }) ?? []
    }))

    if (isLoading) {
        return (
            <Spin />
        )
    }

    return (
        <KanabanBoard
            columns={columns}
            shrink={true}
            onItemClick={onItemClick}
            renderItem={renderKanabanCard}
            isLoading={isLoading}
            hasMore={hasMore}
            loadMore={onLoadMore}
        />
    )
}

ProductionItemKanabanView.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    isLoading: PropTypes.bool,
    hasMore: PropTypes.bool.isRequired,
    onLoadMore: PropTypes.func.isRequired,
    onItemClick: PropTypes.func.isRequired
}


function ProductionList() {
    const initialData = useLoaderData()
    const navigate = useNavigate()
    //const [filtersVisible, setFiltersVisible] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const viewMode = searchParams.get('view') ?? VIEW_MODES.KANABAN
    const [list, hasMore, isLoading, searchParamsParsed, {
        setSort,
        setFilters,
        loadMore
    }] = useFetch({ initialData, autoLoad: viewMode === VIEW_MODES.KANABAN })
    const setViewMode = (mode) => setSearchParams(sp => {
        sp.set('view', mode)
        return sp
    })
    const debouncedChangeHandler = debounce(q => setFilters({ search: q }), 500)


    const handleRowClick = (record) => {
        navigate(generatePath('/production/:id', {
            id: record.id
        }))
    }
    return (
        <Page backLink={false} summary={initialData?.meta?.totalCount ? `${initialData?.meta?.totalCount} Records` : 'No Records'} className='production-list' title={"Production"} header={
            <>
                <Segmented
                    value={viewMode}
                    options={[
                        {
                            value: VIEW_MODES.LIST,
                            icon: <BarsOutlined />,
                        },
                        {
                            value: VIEW_MODES.KANABAN,
                            icon: <AppstoreOutlined />,
                        },
                    ]} onChange={setViewMode}
                />
                <Input.Search style={{ width: '50%' }} placeholder="Search" onChange={(e) => debouncedChangeHandler(e.target.value)} defaultValue={searchParamsParsed?.filter?.search ?? ''} allowClear />

                <div></div>


            </>
        }>

            {viewMode === VIEW_MODES.LIST
                ? <ProductionListView data={list} isLoading={isLoading} hasMore={hasMore} onChangeSort={setSort} onLoadMore={loadMore} onItemClick={handleRowClick} />
                : <ProductionItemKanabanView data={list} isLoading={isLoading} hasMore={hasMore} onLoadMore={loadMore} onItemClick={handleRowClick} />
            }
        </Page>
    )
}

ProductionList.Loader = async ({ request }) => {
    const url = new URL(request.url)
    const { filter, page, sort } = searchParamsToObject(url.searchParams)
    const { data, meta } = await getProductionList({ filter, page, ...sort })
    //console.log({ Loading: data.map(r => r.id) })
    return { data, meta }

}

ProductionList.propTypes = {
    title: PropTypes.string,
}
export default ProductionList
